"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var strings_1 = require("./strings");
exports.CUSTOMER_ACTIONS = [
    strings_1.CHAT_CREATED,
    strings_1.CHAT_ENDED,
    strings_1.CHECKED_IN,
    strings_1.CREATED,
    strings_1.FILE_ADDED,
    strings_1.FILE_REMOVED,
    strings_1.MEMO_CREATED,
    strings_1.MEMO_SHARED,
    strings_1.UPDATED,
];
